module.exports = __webpack_public_path__ + "static/media/logo.f11e5d47.png";